import type { companyagreementApi } from 'app/src/services/welfareportal'
import { getValueFromTypology } from 'app/src/shared/helpers'
import type { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

interface ProductDiscountDisplayProps {
  multiVariants: boolean
  selectedVariant?: companyagreementApi.Variant
}

export function ProductDiscountDisplay({ multiVariants, selectedVariant }: ProductDiscountDisplayProps): ReactElement {
  const { t } = useTranslation('productDetail')

  const getDiscountLabel = (discountType: string): string => {
    if (discountType === 'percentage') {
      return t('ProductDetail.discount.percentage')
    } else if (discountType === 'fixed') {
      return t('ProductDetail.discount.fixed')
    }
    return t('ProductDetail.discount.generic')
  }

  if (
    selectedVariant?.priceDetails?.discountType &&
    selectedVariant?.priceDetails?.discountValue !== undefined &&
    !multiVariants
  ) {
    return (
      <div className='mt-[20px] flex flex-row items-center text-[38px] font-semibold text-[var(--primary-color)]'>
        <div className=''>
          {getDiscountLabel(selectedVariant.priceDetails.discountType)}{' '}
          {getValueFromTypology(selectedVariant.priceDetails.discountType, selectedVariant.priceDetails.discountValue)}
        </div>
      </div>
    )
  }

  return <></>
}
